import { render } from "./LifetimeFooter.vue?vue&type=template&id=0111d474"
import script from "./LifetimeFooter.vue?vue&type=script&lang=js"
export * from "./LifetimeFooter.vue?vue&type=script&lang=js"

import exportComponent from "/home/apriyadi/projects/lifetime/hitting-the-target-australia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__